import React from 'react';
import { ProducerText as StyledProducerText } from './ProducerText.styled';

export interface ProducerTextProps {
  children: React.ReactNode;
  className?: string;
}

export function ProducerText({ children, className }: ProducerTextProps) {
  return (
    <StyledProducerText className={className}>
      {children}
    </StyledProducerText>
  );
}
